"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.camelCaseToTitle = void 0;
/**
 * Converts a camelCase string into a title string.
 * Adds spaces before each capital letter and capitalizes the first letter of each word.
 *
 * @param {string} value  example = doesNotMeetExpectations.
 */
var camelCaseToTitle = function (value) {
    return value
        .replace(/([a-z])([A-Z])/g, '$1 $2') // Add space between lowercase and uppercase
        .replace(/(^|\s)(\w)/g, function (_, space, letter) { return space + letter.toUpperCase(); });
}; // Capitalize each word
exports.camelCaseToTitle = camelCaseToTitle;
